export const signOut = (msal) => {
  localStorage.removeItem('sessionData')
  msal.signOut().then(() => {})
}
export const getSessionData = () => {
  let sessionData = localStorage.getItem('sessionData')

  return sessionData ? JSON.parse(sessionData).sessionData : null
}
export const singIn = (data) => {
  localStorage.setItem('sessionData', JSON.stringify(data))
}
